import { signal } from '@angular/core';

/**
 * Uitklapstaat van een lijst items (kanaal-/poortblokjes met I Tjing-kaarten):
 * een set van keys die van de default afwijken, zodat "default dicht"
 * (Geavanceerd-paneel) en "default open" (Just Now-paneel) dezelfde helper
 * delen. Sessie-lokaal, niet persistent.
 */
export class HdCollapsibleItems {
  private readonly toggled = signal<ReadonlySet<string>>(new Set());

  constructor(private readonly defaultExpanded: boolean) {}

  isExpanded(key: string): boolean {
    return this.defaultExpanded !== this.toggled().has(key);
  }

  toggle(key: string): void {
    this.toggled.update(toggled => {
      const next = new Set(toggled);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }
}
